(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    

class WuffesStickyHeader extends HTMLElement {

  constructor() {
    super();
  }


  connectedCallback() {

    this.header =
      this.closest('.shopify-section') ||
      this.parentElement;


    this.headerIsAlwaysSticky =
      this.getAttribute('data-sticky-type') === 'always';


    this.headerBounds = {};

    this.currentScrollTop = 0;


    this.setHeaderHeight();


    this.resizeHandler =
      this.setHeaderHeight.bind(this);


    window.addEventListener(
      'resize',
      this.resizeHandler
    );


    if (this.headerIsAlwaysSticky) {

      this.header.classList.add(
        'shopify-section-header-sticky'
      );

    }


    this.onScrollHandler =
      this.onScroll.bind(this);


    window.addEventListener(
      'scroll',
      this.onScrollHandler,
      false
    );


    this.createObserver();

  }


  setHeaderHeight() {

    document.documentElement.style.setProperty(
      '--header-height',
      `${this.offsetHeight}px`
    );

  }


  disconnectedCallback() {

    window.removeEventListener(
      'scroll',
      this.onScrollHandler
    );


    window.removeEventListener(
      'resize',
      this.resizeHandler
    );

  }


  createObserver() {

    const observer =
      new IntersectionObserver(
        (entries) => {

          this.headerBounds =
            entries[0].intersectionRect;

          observer.disconnect();

        }
      );


    observer.observe(this);

  }


  onScroll() {

    const scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop;


    if (
      scrollTop > this.currentScrollTop
      &&
      scrollTop > this.headerBounds.bottom
    ) {

      if (!this.headerIsAlwaysSticky) {

        this.header.classList.add(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky'
        );

      }

    }

    else if (
      scrollTop < this.currentScrollTop
      &&
      scrollTop > this.headerBounds.bottom
    ) {

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );


      this.header.classList.remove(
        'shopify-section-header-hidden'
      );

    }

    else if (
      scrollTop <= this.headerBounds.top
    ) {

      if (!this.headerIsAlwaysSticky) {

        this.header.classList.remove(
          'shopify-section-header-hidden',
          'shopify-section-header-sticky',
          'animate'
        );

      }

    }


    this.currentScrollTop =
      scrollTop;

  }

}


/*
  Use a unique custom element name so we do not
  conflict with the theme's original <sticky-header>.
*/

if (!customElements.get('wuffes-sticky-header')) {

  customElements.define(
    'wuffes-sticky-header',
    WuffesStickyHeader
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
 class LmLookBook extends HTMLElement {
  constructor() {
    super();

    this.injectVendorScripts();
    this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem);
    });
  }

  async injectVendorScripts() {
    if (!window.FloatingUICore) {
      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0');
      document.head.appendChild(script);
    }
    if (!window.FloatingUIDOM) {
      await new Promise((r) => setTimeout(r, 500));

      const script = document.createElement('script');
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1');
      document.head.appendChild(script);
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('button');
    const tooltip = elem.querySelector('.lm-tooltip');

    function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(0),
          window.FloatingUIDOM.autoPlacement(),
        ],
      }).then(({ x, y }) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        });
      });
    }

    function showTooltip() {
      tooltip.classList.add('show');
      update();
    }

    function hideTooltip() {
      tooltip.classList.remove('show');
      tooltip.classList.add('hiding');
      setTimeout(() => {
        tooltip.classList.remove('hiding');
      }, 200);
    }

    const events = [
      ['mouseenter', showTooltip],
      ['mouseleave', hideTooltip],
      ['focus', showTooltip],
      ['blur', hideTooltip],
    ];

    // Detect if the device is touch-capable
    const isTouchDevice = window.matchMedia("(pointer: coarse)").matches;

    if (isTouchDevice) {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (tooltip.classList.contains('show')) {
          hideTooltip();
        } else {
          showTooltip();
        }
      });

      // Hide the tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (!elem.contains(e.target)) {
          hideTooltip();
        }
      });
    } else {
      events.forEach(([event, listener]) => {
        btn.addEventListener(event, listener);
      });
    }
  }
}

customElements.define('lumin-lookbook', LmLookBook);


  } catch(e) { console.error(e); }
})();
})();
